import vendorsConfig from "../vendorsConfig";
export const updateManifest = async (appState) => {
    const manifest = document.querySelector('link[rel="manifest"]');
    const appleTouchIcon = document.querySelector(
      "link[rel='apple-touch-icon']"
    );
    const metaTag = document.createElement("meta");
    const manifestUrl = manifest.getAttribute("href");

    if (appleTouchIcon) {
      appleTouchIcon.href = `${
        appState.storeInfo?.logo ||
        `https://qs.${vendorsConfig.SLUG}.dev/static/media/${vendorsConfig.APP_NAME}Jan.4d0a758b184e3ac40bb9aef3bee391e6.svg`
      }`;
    }

    if (metaTag && manifest) {
      const updatedAppName = `${
        appState.storeInfo?.business_name || vendorsConfig.APP_NAME
      }`;
      metaTag.name = "apple-mobile-web-app-title";
      metaTag.content = updatedAppName;
      document.head.appendChild(metaTag);
    }

    if (manifestUrl) {
      try {
        const response = await fetch(manifestUrl);
        const data = await response.json();
        // console.log(response);
        const updatedData = {
          ...data,
          start_url: `${process.env.REACT_APP_PAY_URL}`,
          icons: [
            {
              src: `${
                appState.storeInfo?.logo ||
                `https://qs.${vendorsConfig.SLUG}.dev/static/media/${vendorsConfig.APP_NAME}Jan.4d0a758b184e3ac40bb9aef3bee391e6.svg`
              }`,
              sizes: "64x64 32x32 24x24 16x16",
              type: "image/x-icon",
            },
          ],
          short_name: `${
              appState.storeInfo?.business_name || vendorsConfig.APP_NAME
          }`,
          name: `${appState.storeInfo?.business_name || vendorsConfig.APP_NAME}`,
        };

        const blob = new Blob([JSON.stringify(updatedData)], {
          type: "application/json",
        });
        const manifestBlobUrl = URL.createObjectURL(blob);
        manifest.setAttribute("href", manifestBlobUrl);
      } catch (error) {
      }
    }
  };